import React from 'react';
import { Form, Radio } from 'antd';
import CouponItem from '@/components/SelectDiscountCoupon/component/CouponItem';
import { Icoupon } from '@/redux/reducers/guest';
import { CouponTabStatus } from '@/config';
import { isNil } from '@/utils/number';
import { renderIntlLabel } from '@/utils';
import NoCouponData from '../NoCouponData';
import styles from './index.module.scss';

interface CouponTabProps {
  // 1按有效期，2金额
  sortType?: 1 | 2;
  couponList?: Array<Icoupon>;
  couponTabStatus?: CouponTabStatus;
  onShowEditModal?: (...args) => void;
  onSortRadioChange?: (...args) => void;
}

const CouponTab: React.FC<CouponTabProps> = ({
  sortType,
  couponList,
  couponTabStatus,
  onShowEditModal,
  onSortRadioChange,
}) => {
  const handleRadioChange = (e) => {
    if (onSortRadioChange) {
      onSortRadioChange(e.target.value);
    }
  };

  return (
    <>
      <div className={styles.container}>
        {!couponList || couponList.length === 0 ? (
          <div style={{ marginTop: 120 }}>
            <NoCouponData />
          </div>
        ) : (
          <>
            {!isNil(sortType) && (
              <Form.Item label={renderIntlLabel('guest_coupon_label_type_of_sort')}>
                <Radio.Group value={sortType} onChange={handleRadioChange}>
                  <Radio.Button value={1}>
                    {renderIntlLabel('guest_coupon_label_via_indate')}
                  </Radio.Button>
                  <Radio.Button value={2}>
                    {renderIntlLabel('guest_coupon_label_via_money')}
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            )}
            <div className={styles.couponContainer}>
              {couponList?.map((item) => (
                <CouponItem
                  key={item.id}
                  isCanSelect={false}
                  coupon={item}
                  couponTabStatus={couponTabStatus}
                  onShowEditModal={onShowEditModal}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CouponTab;
